import { graphql } from 'graphql-schema';

export const DROP_IN_PILL_FRAGMENT = graphql(`
  fragment DropInPill on drop_in_slots @_unmask {
    _id
    note
    gender
    deep_link
    hold_expiration
    upcoming_recurring_drop_in_slot_count
    recurring_drop_in {
      _id
      entire_season
    }
  }
`);

const GAME_ROSTER_DROP_IN_SLOTS_FRAGMENT = graphql(
  `
    fragment GameRosterDropInSlots on game_teams @_unmask {
      _id
      drop_in_slots(where: { rsvp: { _is_null: true }, closed_at: { _is_null: true } }) {
        ...DropInPill
      }
    }
  `,
  [DROP_IN_PILL_FRAGMENT]
);

const GAME_ROSTER_RSVPS_FRAGMENT = graphql(`
  fragment GameRosterRsvps on game_teams @_unmask {
    _id
    number_of_women_needed
    number_of_players_needed
    rsvps(where: { response: { _eq: YES } }) {
      _id
      user
      gender
      is_drop_in
      registrant
      profile_picture
      display_name_teams
    }
  }
`);

export const GAME_ROSTER_QUERY = graphql(
  `
    query GameRoster($gameId: uuid!, $teamId: uuid!) {
      currentUser {
        _id
      }
      checkCanSendRsvpReminder(game: $gameId, team: $teamId) {
        reminder_eligible
      }
      game_teams(where: { game: { _eq: $gameId }, team: { _eq: $teamId } }, limit: 1) {
        ...GameRosterRsvps
        ...GameRosterDropInSlots
        upcoming_game_count
        gameByGame {
          _id
          is_tournament
          leagueByLeague {
            _id
            is_daily
            gender
            format_type
            max_dropins_per_game
            min_women
            min_players
            suggested_women
            suggested_players
            sport_detail {
              _id
              formats {
                _id
                format
                gender
                max_players_on_field_total
              }
            }
          }
        }
        teamByTeam {
          _id
          name
          captain_user
          co_captains {
            _id
            user
          }
        }
      }
    }
  `,
  [GAME_ROSTER_DROP_IN_SLOTS_FRAGMENT, GAME_ROSTER_RSVPS_FRAGMENT]
);

export const SHARE_DROP_IN_SLOT = graphql(`
  mutation ShareDropInSlot($dropInSlotId: uuid!) {
    shareDropInSlot(drop_in_slot: $dropInSlotId) {
      dropInSlotByDropInSlot {
        _id
        deep_link
        hold_expiration
      }
    }
  }
`);

export const OPEN_DROP_IN_SLOT = graphql(
  `
    mutation OpenDropInSlot($gameId: uuid!, $teamId: uuid!, $gender: DropInGender!, $note: String) {
      openDropInSlot(game: $gameId, team: $teamId, gender: $gender, note: $note) {
        game_team {
          ...GameRosterDropInSlots
        }
      }
    }
  `,
  [GAME_ROSTER_DROP_IN_SLOTS_FRAGMENT]
);

export const CLOSE_DROP_IN_SLOT = graphql(
  `
    mutation CloseDropInSlot($dropInSlotId: uuid!) {
      closeDropInSlot(drop_in_slot: $dropInSlotId) {
        game_team {
          ...GameRosterDropInSlots
        }
      }
    }
  `,
  [GAME_ROSTER_DROP_IN_SLOTS_FRAGMENT]
);

export const CLOSE_RECURRING_DROP_IN_SLOTS = graphql(
  `
    mutation CloseRecurringDropInSlot($dropInSlotId: uuid!) {
      closeRecurringDropInSlots(drop_in_slot: $dropInSlotId) {
        game_team {
          ...GameRosterDropInSlots
        }
      }
    }
  `,
  [GAME_ROSTER_DROP_IN_SLOTS_FRAGMENT]
);

export const UPDATE_DROP_IN_SLOT = graphql(
  `
    mutation UpdateDropInSlot(
      $dropInSlotId: uuid!
      $entireSeason: Boolean
      $gameCount: Int
      $gender: DropInGender
      $note: String
      $isRecurring: Boolean
    ) {
      updateDropInSlot(
        dropInSlotId: $dropInSlotId
        entireSeason: $entireSeason
        gameCount: $gameCount
        gender: $gender
        note: $note
        isRecurring: $isRecurring
      ) {
        game_team {
          ...GameRosterDropInSlots
        }
      }
    }
  `,
  [GAME_ROSTER_DROP_IN_SLOTS_FRAGMENT]
);

export const REMOVE_REGISTRANT_FROM_DROPIN = graphql(
  `
    mutation RemovePlayerFromDropIn($registrantId: uuid!) {
      removeRegistrantFromDropIn(registrant: $registrantId) {
        user_full_name
        game_team {
          ...GameRosterRsvps
          ...GameRosterDropInSlots
        }
      }
    }
  `,
  [GAME_ROSTER_RSVPS_FRAGMENT, GAME_ROSTER_DROP_IN_SLOTS_FRAGMENT]
);
